import {TableSummary} from "../../../../../domain/out/table-summary";
import {CustomGroup} from "../../../../../domain/in/quote/group/custom-group";
import {TranslationServiceInterface} from "../../../../translation-service.interface";
import {AbstractPricingItemSummaryMapper} from "../abstract-pricing-item-summary.mapper";
import {FrAcLsSynthesisMapper} from "./ls/fr.ac.ls.synthesis.mapper";
import {FrAcSolSynthesisMapper} from "./sol/fr.ac.sol.synthesis.mapper";
import {FrAcVtSynthesisMapper} from "./vt/fr.ac.vt.synthesis.mapper";
import {FrAcSasSynthesisMapper} from "./sas/fr.ac.sas.synthesis.mapper";
import {FrAcFonSynthesisMapper} from "./fon/fr.ac.fon.synthesis.mapper";
import {FrAcCafSynthesisMapper} from "./caf/fr.ac.caf.synthesis.mapper";
import {FrAcDasriSynthesisMapper} from "./dasri/fr.ac.dasri.synthesis.mapper";
import {FrAcThreeDSynthesisMapper} from "./three_d/fr.ac.three_d.synthesis.mapper";

export class TableSummaryAcMapper {
    private readonly mappers: Map<string, AbstractPricingItemSummaryMapper>;

    constructor(protected translationService: TranslationServiceInterface) {
        this.mappers = new Map<string, AbstractPricingItemSummaryMapper>([
            ['SOL', new FrAcSolSynthesisMapper(translationService)],
            ['LS', new FrAcLsSynthesisMapper(translationService)],
            ['VT', new FrAcVtSynthesisMapper(translationService)],
            ['SAS', new FrAcSasSynthesisMapper(translationService)],
            ['FON', new FrAcFonSynthesisMapper(translationService)],
            ['CAF', new FrAcCafSynthesisMapper(translationService)],
            ['DASRI', new FrAcDasriSynthesisMapper(translationService)],
            ['3D', new FrAcThreeDSynthesisMapper(translationService)],
        ]);
    }

    public async getTablesSummary(group: CustomGroup, serviceCode: string, currency: string, view: string, locale: string): Promise<TableSummary[]> {
        const tableSummaries: TableSummary[] = [];
        const mapper = this.mappers.get(serviceCode);
        if (mapper) {
            const tableSummary = new TableSummary();
            tableSummary.pricingItems = await Promise.all(group.pricingItems.map(pricingItem =>
                mapper.pricingItemToProductItemSummary(pricingItem, currency, locale)
            ));
            tableSummaries.push(tableSummary);
        }
        return tableSummaries;
    }

}